// extracted by mini-css-extract-plugin
export var desktop = "styles-module--desktop--a25c0";
export var mobile = "styles-module--mobile--db735";
export var wrapper = "styles-module--wrapper--1998c";